import { Table } from 'react-bootstrap';
import AccordionCard from '../AccordionCard';

const PaymentFileFormatNew = () => {
  return (
    <>
      <AccordionCard title="NEW --- Company Record Format" parent="paymentFileAccordion">
        <p className="fs-5 fst-italic mb-1">First record in file is always a Company Record.</p>
        <p className="fs-5 fst-italic mb-1">In text files, columns are separated by spaces.</p>
        <Table className="m-0" striped responsive>
          <thead className="fs-4">
            <tr>
              <th>Column #</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Always “C” for Company Record</td>
            </tr>
            <tr>
              <td>2</td>
              <td>I.D. Number given when you set up the company.</td>
            </tr>
            <tr>
              <td>Example:</td>
              <td>C 10463</td>
            </tr>
          </tbody>
        </Table>
      </AccordionCard>
      <AccordionCard title="NEW --- Property Record Format" parent="paymentFileAccordion">
        <p className="fs-5 fst-italic mb-1">In text files, columns are separated by spaces.</p>
        <Table className="m-0" striped responsive>
          <thead className="fs-4">
            <tr>
              <th>Column #</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Always “P” for Property Record</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Property Serial Number</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Tax Balance Due (amount you are paying.)</td>
            </tr>
            <tr>
              <td>Example:</td>
              <td>P 010470003 4325</td>
            </tr>
          </tbody>
        </Table>
      </AccordionCard>
    </>
  );
};

export default PaymentFileFormatNew;
